
import { Component, Vue, Prop } from "vue-property-decorator";

import akt_routes from "@/api/routes/akt";

import CAktLabel from "@/components/akt/Label.vue";
import Preloader from "@/components/Preloader.vue";
import CPrint from "@/components/Print.vue";
import CAktTestingSubscriptionResult, {
  IAktSub
} from "@/components/akt/SubscriptionResult.vue";
import CAktReviewDelegation from "@/views/notifications/components/AktReviewDelegation.vue";

import { IAktTest, IAktTestSub } from "@/models/akt/assignment_subscription";
import { EAktType } from "@/models/akt/question_version";
import {
  EAktAssignmentUserWorkplaceType,
  IAssignmentUserWorkplaceInfo
} from "@/models/akt/assignment_user_workplace";

@Component({
  name: "VAktTesting",
  components: {
    Preloader,
    CAktTestingSubscriptionResult,
    CPrint,
    CAktLabel,
    CAktReviewDelegation
  }
})
export default class VAktTesting extends Vue {
  @Prop({ required: true }) id!: string;

  public EAktAssignmentUserWorkplaceType = EAktAssignmentUserWorkplaceType;

  public preload: boolean = false;
  public test_info: IAktTest | null = null;
  public workplace: IAssignmentUserWorkplaceInfo | null = null;

  public all_subs: IAktTestSub[] = [];
  public preliminary_subs: IAktTestSub[] = [];
  public main_subs: IAktTestSub[] = [];
  public sub_count: number = 0;

  protected async created() {
    await Promise.all([this.loadWorkplace(), this.loadTest()]);
  }

  public syncTestInfo(subscription: IAktSub) {
    this.test_info!.passing_percent = subscription.workplace.passing_percent;
    this.test_info!.completion_percent =
      subscription.workplace.completion_percent;
    this.test_info!.status_id = subscription.workplace.status_id;
    this.test_info!.result_status_id = subscription.workplace.result_status_id;

    const sub = this.all_subs.find(s => s.id === subscription.id);
    sub!.is_correct = subscription.is_correct;
    sub!.is_checked = subscription.is_checked;
  }

  private async loadWorkplace() {
    return this.$api
      .get(akt_routes.get_workplace_info(this.id))
      .then(({ data: res }: { data: IAssignmentUserWorkplaceInfo }) => {
        this.workplace = res;
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  private async loadTest() {
    this.preload = true;

    return this.$api
      .get(akt_routes.get_workplace_testing(this.id))
      .then(({ data: res }: { data: IAktTest }) => {
        this.test_info = res;

        res.subscriptions.forEach(sub => {
          if (sub.akt_type_id === EAktType.PRELIMINARY) {
            this.preliminary_subs.push(sub);
          } else {
            this.main_subs.push(sub);
          }
        });

        this.all_subs = res.subscriptions;
        this.sub_count = this.all_subs.length;
      })
      .finally(() => {
        this.preload = false;
      });
  }

  public showDelegateModal() {
    this.$modal.show("delegate_akt_modal");
  }

  public hideDelegateModal() {
    this.$modal.hide("delegate_akt_modal");
  }

  public hideDelegate() {
    if (this.workplace) {
      this.workplace.allow_delegation = false;
    }

    this.hideDelegateModal();
  }
}
